module.exports = __webpack_public_path__ + "817074456737df0a00c77936cea22619.svg";